export default __webpack_public_path__ + "static/media/cone.bc3a11ab.png";